export function isAnswered(question) {
  const answer = question.selectedAnswer;
  if (Array.isArray(answer)) return answer.length > 0;
  if (typeof answer === "string") return answer.trim() !== "";
  return answer !== null && answer !== undefined;
}

export function answeredCount(questions) {
  return questions.filter(isAnswered).length;
}

export function isSubjectComplete(subject) {
  return subject.questions.every(isAnswered);
}

export function formatAnswer(question) {
  const answer = question.selectedAnswer;
  if (Array.isArray(answer)) return answer.join(", ");
  return answer === null || answer === undefined ? "" : String(answer);
}
